import {
  LIST_OF_GENERAL_FLEET_DETAIL_SUCCESS,
  LIST_OF_GENERAL_FLEET_DETAIL_ERROR,
  LIST_OF_GENERAL_FLEET_DETAIL_START,
  LIST_OF_LEGEL_FLEET_DETAIL_SUCCESS,
  LIST_OF_LEGEL_FLEET_DETAIL_START,
  LIST_OF_LEGEL_FLEET_DETAIL_ERROR,
  LIST_OF_FINANCE_FLEET_DETAIL_SUCCESS,
  LIST_OF_FINANCE_FLEET_DETAIL_ERROR,
  LIST_OF_FINANCE_FLEET_DETAIL_START,
  GENERAL_VIEW_LIST_SUCCESS,
  GENERAL_VIEW_LIST_ERROR,
  GENERAL_VIEW_LIST_START,
  LEGAL_VIEW_LIST_SUCCESS,
  LEGAL_VIEW_LIST_ERROR,
  LEGAL_VIEW_LIST_START,
  SAVE_GENRAL_FLEET_SUCCESS,
  SAVE_GENRAL_FLEET_ERROR,
  SAVE_GENRAL_FLEET_REQUEST,
  SAVE_LEGAL_FLEET_START,
  SAVE_LEGAL_FLEET_SUCCESS,
  SAVE_LEGAL_FLEET_ERROR,
  ClEAR_ALL_DATA,
} from "../Constants/ListOfFleetConstant";
const initialState = {
  loading: false,
  genalFleetdata: [],
  leegalFleetData: [],
  financeFleetData: [],
  genralList: null,
  legalList: [],
};

export default function LIstOfFleetReducer(
  state = { ...initialState },
  action
) {
  switch (action.type) {
    case LIST_OF_GENERAL_FLEET_DETAIL_START:
      return {
        ...state,
        loading: true,
      };
    case LIST_OF_GENERAL_FLEET_DETAIL_SUCCESS:
      return {
        ...state,
        genalFleetdata: action.payload,
        loading: false,
      };
    case LIST_OF_GENERAL_FLEET_DETAIL_ERROR:
      return {
        ...state,
        loading: false,
        message: action.error.message,
      };
    case LIST_OF_LEGEL_FLEET_DETAIL_START:
      return {
        ...state,
        loading: true,
      };
    case LIST_OF_LEGEL_FLEET_DETAIL_SUCCESS:
      return {
        ...state,
        leegalFleetData: action.payload,
        loading: false,
      };
    case LIST_OF_LEGEL_FLEET_DETAIL_ERROR:
      return {
        ...state,
        loading: false,
        message: action.error.message,
      };
    case LIST_OF_FINANCE_FLEET_DETAIL_START:
      return {
        ...state,
        loading: true,
      };
    case LIST_OF_FINANCE_FLEET_DETAIL_SUCCESS:
      return {
        ...state,
        financeFleetData: action.payload,
        loading: false,
      };
    case LIST_OF_FINANCE_FLEET_DETAIL_ERROR:
      return {
        ...state,
        loading: false,
        message: action.error.message,
      };
    case GENERAL_VIEW_LIST_START:
      return {
        ...state,
        loading: true,
      };
    case GENERAL_VIEW_LIST_SUCCESS:
      return {
        ...state,
        genralList: action.payload,
        loading: false,
      };
    case GENERAL_VIEW_LIST_ERROR:
      return {
        ...state,
        loading: false,
        message: action.error.message,
      };
    case LEGAL_VIEW_LIST_START:
      return {
        ...state,
        loading: true,
      };
    case LEGAL_VIEW_LIST_SUCCESS:
      return {
        ...state,
        legalList: action.payload,
        loading: false,
      };
    case LEGAL_VIEW_LIST_ERROR:
      return {
        ...state,
        loading: false,
        message: action.error.message,
      };
    case SAVE_GENRAL_FLEET_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case SAVE_GENRAL_FLEET_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case SAVE_GENRAL_FLEET_ERROR:
      return {
        ...state,
        loading: false,
      };
    case SAVE_LEGAL_FLEET_START:
      return {
        ...state,
        loading: true,
      };
    case SAVE_LEGAL_FLEET_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case SAVE_LEGAL_FLEET_ERROR:
      return {
        ...state,
        loading: false,
      };
    case ClEAR_ALL_DATA:
      return {
        ...state,
        loading: false,
        genralList: null,
        legalList: [],
        // message: action.error.message,
      };

    default:
      return state;
  }
}
